module.exports = __webpack_public_path__ + "static/media/person.20a629c4.svg";